<template>
  <div :class="['quiz-dark-wrapper', { 'quiz4-dark-wrapper': isQuizV4 }]">
    <main-header is-dark />
    <ProgressBar is-dark />
    <slot />
  </div>
</template>

<script lang="ts" setup>
import ProgressBar from '@/components/quiz/ProgressBar.vue';

const { $versions } = useNuxtApp();

const isQuizV4 = computed((): boolean => {
  return $versions.value.quiz === '4';
});
</script>

<style lang="scss" scoped>
.quiz-dark-wrapper {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: $text-color;
  display: flex;
  flex-direction: column;
}

.quiz4-dark-wrapper {
  background: $bg-quiz4;
}
</style>
